module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h4 class="center">Merge to <a href="/#person/'+
((__t=( mergeToPersonId ))==null?'':__t)+
'" target="_blank">'+
((__t=( mergeToPersonName ))==null?'':__t)+
'</a></h4>\r\n\r\n<table class="table table-hover well">\r\n    <thead>\r\n    <tr>\r\n        <th>Contact type</th>\r\n        <th>Contact data</th>\r\n        <th>Is preferred</th>\r\n        <th></th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    ';
 _.each(contacts, function(contact){ 
__p+='\r\n\r\n        ';
 if (isMergedContact(contact)) { 
__p+='\r\n            <tr>\r\n                <td>'+
((__t=( contact.type ))==null?'':__t)+
'</td>\r\n                <td>'+
((__t=( contact.data ))==null?'':__t)+
'</td>\r\n                <td>\r\n                    <input type="checkbox" value="" onclick="return false;" ';
 if (contact.preferred) { 
__p+=' checked ';
 } 
__p+=' >\r\n                </td>\r\n                <td><span class="control-label glyphicon glyphicon-remove-circle clickable remove" id="'+
((__t=( getStringified(contact) ))==null?'':__t)+
'" title="Remove"></span></td>\r\n            </tr>\r\n        ';
 } else { 
__p+='\r\n            <tr class="deprecated-header">\r\n                <td>'+
((__t=( contact.type ))==null?'':__t)+
'</td>\r\n                <td>'+
((__t=( contact.data ))==null?'':__t)+
'</td>\r\n                <td>\r\n                    <input type="checkbox" value="" onclick="return false;" ';
 if (contact.preferred) { 
__p+=' checked ';
 } 
__p+=' >\r\n                </td>\r\n            </tr>\r\n        ';
 } 
__p+='\r\n\r\n    ';
 }) 
__p+='\r\n    </tbody>\r\n</table>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/persons/merge-to-person-contacts-view.html
// module id = 485
// module chunks = 0